import React, { useContext, useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Spinner } from "react-bootstrap";
import moment from "moment/moment";
import { getBillingPlans } from "../../../api/context/billing";
import { subscribe } from "../checkout";
import { SelectionContext } from "../../../Context/Store";
import PlanCard from "./PlanCard";
import PlanSwitchConfirmModal from "./PlanSwitchConfirmModal";
import CancelSubscriptionModal from "./CancelSubscriptionModal";

const PlansModal = ({ isOpen, toggle, currentPlanCode }) => {
  const { billingBalance, refreshBillingBalance } = useContext(SelectionContext);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingCode, setProcessingCode] = useState(null);
  const [confirmPlan, setConfirmPlan] = useState(null);
  const [showCancelUpgrade, setShowCancelUpgrade] = useState(false);

  const subscription = billingBalance?.subscription;
  const scheduledNextPlan = billingBalance?.scheduledNextPlan;
  const scheduledStartDate = scheduledNextPlan?.scheduledStartAt
    ? moment(scheduledNextPlan.scheduledStartAt).format("MMM D, YYYY")
    : null;

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    getBillingPlans()
      .then((res) => {
        if (res?.data?.success) setPlans(res.data.data || []);
      })
      .finally(() => setLoading(false));
  }, [isOpen]);

  const handleAskConfirm = (plan) => setConfirmPlan(plan);

  const handleConfirmSubscribe = async () => {
    if (!confirmPlan) return;
    setProcessingCode(confirmPlan.code);
    await subscribe(confirmPlan.code, confirmPlan.name, {
      onSuccess: () => {
        refreshBillingBalance();
        setConfirmPlan(null);
        toggle();
      },
      onDismiss: () => setProcessingCode(null),
    });
    setProcessingCode(null);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="billing-modal billing-modal-plans"
        size="xl"
        centered
        scrollable
      >
        <ModalHeader toggle={toggle}>Choose a plan</ModalHeader>
        <ModalBody>
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" size="sm" />
            </div>
          ) : (
            <div className="billing-plans-grid">
              {[...plans]
                .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
                .map((plan) => (
                  <PlanCard
                    key={plan.code}
                    plan={plan}
                    isCurrent={currentPlanCode === plan.code}
                    isScheduled={scheduledNextPlan?.planCode === plan.code}
                    scheduledStartDate={scheduledStartDate}
                    isProcessing={processingCode === plan.code}
                    onSubscribe={handleAskConfirm}
                    onCancelUpgrade={() => setShowCancelUpgrade(true)}
                    hidePopular={!!subscription}
                  />
                ))}
            </div>
          )}
        </ModalBody>
      </Modal>

      <PlanSwitchConfirmModal
        isOpen={!!confirmPlan}
        toggle={() => setConfirmPlan(null)}
        targetPlan={confirmPlan}
        currentSubscription={subscription}
        scheduledNextPlan={scheduledNextPlan}
        onConfirm={handleConfirmSubscribe}
        isProcessing={!!processingCode}
      />

      <CancelSubscriptionModal
        isOpen={showCancelUpgrade}
        toggle={() => setShowCancelUpgrade(false)}
        subscription={subscription}
        scheduledNextPlan={scheduledNextPlan}
        mode="upgrade"
      />
    </>
  );
};

export default PlansModal;
